import { Component, Input } from '@angular/core';
import ButtonComponent from '@app/shared/button/button.component';
import { IMenuItem } from '@app/shared/common/match/match-submenu/type';
import SpinnerComponent from '@app/shared/common/spinner/spinner.component';
import SvgIconComponent from '@app/shared/svg-icon/svg-icon.component';
import AppComponentBase from '@shared/common/app-component-base';
import UtilsModule from '@shared/utils/utils.module';
import { isEmpty, isNil } from 'lodash';
import { MenuModule } from 'primeng/menu';

@Component({
    selector: 'app-actions-cta',
    imports: [MenuModule, ButtonComponent, UtilsModule, SvgIconComponent, SpinnerComponent],
    templateUrl: './actions-cta.component.html',
    styleUrl: './actions-cta.component.less',
})
class ActionsCtaComponent extends AppComponentBase {
    @Input() menuItems: IMenuItem[] = [];

    @Input() isLoading: boolean = false;

    get isDisabled(): boolean {
        return this.hasNoActions || this.isLoading;
    }

    get hasNoActions(): boolean {
        return isEmpty(this.menuItems);
    }

    showItem(item: IMenuItem): boolean {
        return isNil(item.permissions)
            ? true
            : this.isGrantedAny(...item.permissions);
    }
}

export default ActionsCtaComponent;
